import { toRef, computed } from 'vue';

export function useModelProxy(props, emit) {
	const modelRef = toRef(props, 'modelValue');
	const model = computed({
		get: () => modelRef.value,
		set: value => emit('update:modelValue', value),
	});
	return model;
}
